// import React, { useState, useEffect } from 'react';
// import './ThemeAndVision.css';
// import ApiService from '../../../services/apiService';

// const ThemeAndVision = () => {
//   const [achievements, setAchievements] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchAchievements = async () => {
//       try {
//         setLoading(true);
//         console.log('🔄 Loading achievements from WordPress API...');
        
//         const response = await ApiService.getAchievements();
//         console.log('📥 API Response received:', response);
        
//         if (response.data && response.data.length > 0) {
//           // Transform WordPress API response to match our component structure
//           const transformedData = response.data.map((item) => {
//             // Determine the link - priority: ACF link > file upload > default
//             let link = '#';
//             if (item.acf?.link) {
//               link = item.acf.link;
//             } else if (item.acf?.upload_file?.url) {
//               link = item.acf.upload_file.url;
//             }
            
//             return {
//               id: item.id,
//               type: item.acf?.type || 'General Achievement',
//               title: item.acf?.heading || item.title.rendered,
//               description: item.content?.rendered || `Achievement details for ${item.title.rendered}`,
//               year: new Date(item.date).getFullYear().toString(),
//               link: link
//             };
//           });
          
//           console.log('✅ Using WordPress API achievements data:', transformedData);
//           console.log('📊 Number of achievements from API:', transformedData.length);
          
//           setAchievements(transformedData);
//           setError(null);
//         } else {
//           console.log('⚠️  No achievements from API');
//           setAchievements([]);
//           setError(null);
//         }
//       } catch (err) {
//         console.error('❌ Error loading achievements from WordPress API:', err);
//         setAchievements([]);
//         setError('Failed to load achievements');
//       } finally {
//         setLoading(false);
//         console.log('🏁 Achievements loading completed');
//       }
//     };

//     fetchAchievements();
//   }, []);

//   return (
//     <section className="ray-theme-vision-section">
//       <div className="ray-theme-vision-container">
//         <div className="ray-section-intro">
//           <h2>Rayalaseema University</h2>
//           <p className="ray-motto">"Empowering through Knowledge, Enlightenment through Education"</p>
//         </div>

//         <div className="ray-main-content-wrapper">
//           {/* Achievements Section - Left */}
//           <div className="ray-achievements-section">
//             <div className="ray-section-header">
//               <h2>Student & Faculty Achievements</h2>
//               <div className="ray-section-divider"></div>
//             </div>
//             <div className="ray-achievements-scroll-container">
//               <div className="ray-achievements-scroll-content">
//                 {loading ? (
//                   <div className="ray-loading-state" style={{ 
//                     textAlign: 'center', 
//                     padding: '20px', 
//                     fontStyle: 'italic',
//                     opacity: 0.7 
//                   }}>
//                     Loading achievements...
//                   </div>
//                 ) : achievements.length > 0 ? (
//                   achievements.map((achievement, index) => (
//                     <div 
//                       key={achievement.id || index} 
//                       className="ray-achievement-card"
//                       onClick={() => {
//                         if (achievement.link && achievement.link !== '#') {
//                           if (achievement.link.startsWith('http://') || achievement.link.startsWith('https://')) {
//                             window.open(achievement.link, '_blank', 'noopener,noreferrer');
//                           }
//                         }
//                       }}
//                       style={{ 
//                         cursor: (achievement.link && achievement.link !== '#') ? 'pointer' : 'default' 
//                       }}
//                     >
//                       <div className="ray-achievement-type">{achievement.type}</div>
//                       <div className="ray-achievement-year">{achievement.year}</div>
//                       <h3 className="ray-achievement-title">{achievement.title}</h3>
//                       <p className="ray-achievement-description">
//                         {achievement.description.length > 150 
//                           ? `${achievement.description.substring(0, 150)}...` 
//                           : achievement.description}
//                       </p>
//                       {achievement.link && achievement.link !== '#' && (
//                         <div className="ray-achievement-link-indicator" style={{
//                           marginTop: '8px',
//                           fontSize: '12px',
//                           color: '#007bff',
//                           fontWeight: 'bold'
//                         }}>
//                           📎 Click to view details
//                         </div>
//                       )}
//                     </div>
//                   ))
//                 ) : (
//                   <div className="ray-no-achievements" style={{ 
//                     textAlign: 'center', 
//                     padding: '20px',
//                     color: '#666' 
//                   }}>
//                     No achievements available
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* Vision & Mission Section - Right */}
//           <div className="ray-vision-mission-wrapper">
//             <div className="ray-vision-section">
//               <div className="ray-section-header">
//                 <h2>Our Vision</h2>
//                 <div className="ray-section-divider"></div>
//               </div>
//               <div className="ray-vision-content">
//                 <div className="ray-vision-statement">
//                   <p>
//                     Our vision is to achieve national distinction for creativity, 
//                     innovation, and excellence. We aspire to become a leader in 
//                     higher education through our commitment to teaching, research, 
//                     scholarship, and social action. By leading in these areas, 
//                     we aim to contribute to the building of a more humane, just, 
//                     and sustainable world.
//                   </p>
//                 </div>
//               </div>
//             </div>
            
//             <div className="ray-mission-section">
//               <div className="ray-section-header">
//                 <h2>Our Mission</h2>
//                 <div className="ray-section-divider"></div>
//               </div>
//               <div className="ray-mission-content">
//                 <ul className="ray-mission-list">
//                   <li>
//                     <p>Rayalaseema University is committed to the highest standards of 
//                       academic excellence and human values. The University is devoted 
//                       to the pursuit of knowledge, wisdom, discovery, and creativity.</p>
//                   </li>
//                   <li>
//                     <p> It fosters personal and intellectual growth to prepare students for 
//                       productive careers, meaningful lives, and responsible citizenship in 
//                       a global society. The University adheres to the core values of respect, 
//                       compassion and social responsibility</p>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ThemeAndVision;
import React from "react";
import "./ThemeAndVision.css";

const ThemeAndVision = () => {
  return (
    <section className="ray-theme-vision-section">
      <div className="ray-theme-vision-container">

        <div className="ray-board">
          <h2 className="ray-university-title">
            Vision and Mission
          </h2>

          <div className="ray-two-column">

            {/* LEFT SIDE */}
            <div className="ray-left">

              {/* VISION */}
              <div className="ray-block">
                <h3 className="ray-heading">VISION</h3>
                <p>
                  To achieve national distinction for creativity, innovation and
                  excellence, through quality teaching, research in higher
                  education, with inclusiveness, social equilibrium and contribute
                  to the building of a humane, scientific and progressive society.
                </p>
              </div>

              {/* MISSION */}
              <div className="ray-block">
                <h3 className="ray-heading">MISSION</h3>
                <ul>
                  <li>
                    To provide an educational environment where students can
                    realize their full potential in their chosen discipline and
                    attain quality education to face the challenges of the future.
                  </li>
                  <li>
                    To implement a variety of high-quality programs at
                    undergraduate, postgraduate and doctoral levels for all
                    specializations and disciplines.
                  </li>
                </ul>
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="ray-right">
              <div className="ray-block">
                <h3 className="ray-heading">CORE VALUES</h3>

                <div className="ray-core-item">
                  <strong>Integrity and Ethics</strong>
                  <p>
                    Rayalaseema University emphasizes honesty, transparency, and
                    ethical conduct in all activities.
                  </p>
                </div>

                <div className="ray-core-item">
                  <strong>Respect</strong>
                  <p>
                    The University promotes inclusivity and dignity for all
                    members of the community.
                  </p>
                </div>

                <div className="ray-core-item">
                  <strong>Responsibility</strong>
                  <p>
                    Instilling accountability and positive contribution to
                    society.
                  </p>
                </div>

                <div className="ray-core-item">
                  <strong>Excellence</strong>
                  <p>
                    Commitment to high standards and continuous improvement.
                  </p>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default ThemeAndVision;
